// Helpers shared by the game cards (ActivityEntry) and the versus intro.

const COLORS = {
	Hvid: '#FCFCFC',
	Sort: '#2f2d2d',
	Grå: '#808080',
	Rød: '#FF2222',
	Lyserød: '#FFC0CB',
	Mørkerød: '#8B0000',
	Blå: '#0000FF',
	Lyseblå: '#ADD8E6',
	Mørkeblå: '#0000B9',
	Grøn: '#008000',
	Lysegrøn: '#90EE90',
	Mørkegrøn: '#006400',
	Gul: '#FFFF00',
	Lysegul: '#FFFFE0',
	Mørkegul: '#FFD700',
	Lilla: '#800080',
	Lyselilla: '#D8BFD8',
	Mørkelilla: '#4B0082',
	Orange: '#FFA500',
	Lyseorange: '#FFDAB9',
	Mørkeorange: '#FF8C00',
}

// DHF colour name ("Blå") to a css colour, null when unknown.
export function translateColor(color)
{
	return COLORS[color] ?? null
}

// A match is shown as home team VS away team. Imported matches carry
// homeTeam/awayTeam (used only while the name still matches them, it can be
// edited in admin). A match typed in admin is written "Tvis vs Holstebro":
// " - " is not used, as it shows up in team and activity names too.
export function splitTeams(entry)
{
	if (entry.homeTeam && entry.awayTeam && entry.eventName === entry.homeTeam + ' - ' + entry.awayTeam)
	{
		return [entry.homeTeam, entry.awayTeam]
	}

	const parts = (entry.eventName ?? '').split(/\s+vs\.?\s+/i).map((part) => part.trim())
	if (parts.length === 2 && parts[0] !== '' && parts[1] !== '')
	{
		return parts
	}

	return null
}

// The imported row name ends in the match date ("U7 piger uøvet - Midt
// 24.10.26"), which is not needed on a screen that only shows today.
export function withoutDate(name)
{
	return (name ?? '').replace(/\s*\d{1,2}\.\d{1,2}\.\d{2,4}$/, '')
}

// Lets a long team name wrap only between words, never at the hyphen of
// e.g. "Mejdal-Halgård" (a word joiner after each hyphen), and keeps a
// trailing team number with the word before it ("DØ 2").
export function keepHyphens(name)
{
	return name.replace(/-/g, '-⁠').replace(/ (\d+)$/, ' $1')
}

// Started and not ended yet, the same test the cards use for their green look.
export function isRunning(entry)
{
	const now = new Date()
	const current = now.getHours() * 100 + now.getMinutes()
	return parseInt(entry.timeFrom.replace(':', '')) <= current && parseInt(entry.timeToo.replace(':', '')) >= current
}
